export enum FormFieldErrorMessages {
  MinimumValue = 'Number(s) must be greater or equal to 0',
  MaximumWeeklyForecast = 'Only up to 40 is allowed',
  MinimumDate = 'End date must be later than start date',
  Required = 'This field is required',
  TypeError = 'Please enter a valid value',
}
